/**
 * Each category has an image defined as the key in Cloudinary. The name you can find in
 * the repository where images are stored.
 *
 * https://github.com/photolane/parabo-product-images/tree/master/categories
 */
const PRODUCT_CATEGORIES = [
  {
    id: 'print-sets',
    url: '/print-sets',
    image: 'categories/printsets',
    banner: true,
    data: [
      {
        subCategories: [
          'custom-photo-holiday-cards',
          'custom-photo-greeting-cards',
        ],
        products: [
          'square-prints',
          'classic-prints',
          'tiny-square-prints',
          "photobooth-magnets"
        ],
        productsFirst: true,
      },
    ],
  },
  {
    id: 'wall-art',
    url: '/wall-art',
    image: 'categories/wallart',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'acrylic-prints',
          'wrapped-canvas-prints',
          'framed-art-prints',
          'metal-wall-prints',
          'engineer-prints',
          'square-engineer-prints',
          'framed-prints',
          'artprint',
          'news-print',
        ],
      },
    ],
  },
  {
    id: 'desk',
    url: '/desk',
    image: 'categories/desk',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'metal-desk-prints',
          'square-prints',
          "acrylic-magnets",
          'wood-block',
        ],
      },
    ],
  },
  {
    id: 'photo-books',
    url: '/photo-books',
    image: 'categories/books',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'softcover-books',
          'hardcover-book',
          'premium-hardcover-books'
        ],
      },
    ],
  },
  {
    id: 'calendars',
    url: '/calendars',
    image: 'categories/calendars',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          // 'wall-calendar-new',
          'engineer-print-calendar',
          'wall-calendar',
          'wall-calendar-large',
          // 'desktop-calendar',
          // 'desktop-calendar-flip',
        ],
      },
    ],
  },
  {
    id: 'display',
    url: '/display',
    image: 'categories/display',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          "acrylic-magnets",
          "photobooth-magnets",
          // 'square-print-photo-album',
          'wooden-rails',
          'wood-block',
          // 'good-hangups',
          'photo-ropes',
          // 'gold-square-frame',
          // 'skeleton-clips',
          // 'washi-tape',
          // 'clip-lights',
          'square-envelopes',
        ],
      },
    ],
  },
  {
    id: 'gifts',
    url: '/gifts',
    image: 'categories/gifts',
    banner: true,
    data: [
      {
        subCategories: ['gifts-under-20', 'gifts-under-50'],
        products: ['giftcard'],
      },
    ],
  },
  {
    id: 'gifts-under-20',
    url: '/gifts-under-20',
    name: 'Shop Gifts Under $20',
    image: 'categories/gifts20',
    shortDescription:
      'Turn your best moments and memories into presents they’ll cherish, and stuff their stockings with personalized gifts that’ll make them smile. ',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'square-prints',
          'metal-desk-prints',
          'classic-prints',
          'artprint',
          'softcover-books',
          // 'gold-square-frame',
          'wood-block',
        ],
      },
    ],
  },
  {
    id: 'gifts-under-50',
    url: '/gifts-under-50',
    name: 'Shop Gifts Under $50',
    image: 'categories/gifts50',
    shortDescription:
      'You’ll be the best gift giver around. Turn your most special photos into beautiful keepsakes.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'engineer-prints',
          'metal-wall-prints',
          // 'framed-photo-grid',
          'hardcover-book',
          // 'framed-art-prints',
          'news-print',
          // 'desktop-calendar',
          // 'desktop-calendar-flip',
          'wall-calendar',
          'wall-calendar-large',
          'wooden-rails',
        ],
      },
    ],
  },
  {
    id: 'ep',
    url: '/ep',
    name: 'Engineer Prints',
    image: 'categories/ep',
    shortDescription:
      'Make a BIG impact with your favorite photo turned into a three-foot-wide print on easy to hang lightweight paper.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['engineer-prints', 'square-engineer-prints', 'engineer-print-calendar'],
      },
    ],
  },
  {
    id: 'last-minute-gifts',
    url: '/last-minute-gifts',
    name: 'Last Minute Gifts',
    image: 'categories/lastminutegifts',
    shortDescription:
      'We’ve extended our shipping deadline on these products! We are able to get them out the door more quickly than other things, so you can order through midnight on December 17th and still get them under the tree in time.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'engineer-prints',
          'square-engineer-prints',
          'engineer-print-calendar',
          'artprint',
          'news-print',
          'wooden-rails',
          // 'skeleton-clips',
          'giftcard',
        ],
      },
    ],
  },
  {
    id: 'photo-gifts-for-grandparents',
    url: '/photo-gifts-for-grandparents',
    name: 'Gift for Grandparents',
    image: 'categories/grandparents',
    shortDescription:
      'Every grandparent loves photos of their fantastic family! Fill a photo book or frame with the faces they love most.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'wrapped-canvas-prints',
          // 'framed-art-prints',
          'hardcover-book',
          'classic-prints',
          // 'framed-photo-grid',
          'wall-calendar',
          'wall-calendar-large',
          'photo-ropes',
        ],
      },
    ],
  },
  {
    id: 'photo-gifts-for-best-friends',
    url: '/photo-gifts-for-best-friends',
    name: 'Gift for the Best of Friends',
    image: 'categories/bff',
    shortDescription:
      'Remember all the fun times together with a photo gift made from your favorite memories.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'square-prints',
          // 'framed-photo-grid',
          // 'desktop-calendar',
          'engineer-prints',
          // 'foil-bordered-square-prints',
          'artprint',
          'wooden-rails',
          'softcover-books',
          'news-print',
          'wall-calendar-large',
          'giftcard',
        ],
      },
    ],
  },
  {
    id: 'photo-gift-stocking-stuffers',
    url: '/photo-gift-stocking-stuffers',
    name: 'Stocking Stuffers',
    image: 'categories/stocking',
    shortDescription:
      'Fill their stockings with joyful reminders of your best moments. From Tiny Prints to their very own mini photo books - kids love to see themselves in print.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'tiny-square-prints',
          'softcover-books',
          // 'desktop-calendar-flip',
          'square-prints',
          'wood-block',
          'photo-ropes',
          // 'washi-tape',
          // 'skeleton-clips',
          'giftcard',
        ],
      },
    ],
  },
  {
    id: 'custom-photo-holiday-cards',
    url: '/custom-photo-holiday-cards',
    customPage: true,
    image: 'categories/cards',
    data: [
      {
        subCategories: [],
        products: ['photo-card', 'photo-card-foil'],
      },
    ],
  },
  {
    id: 'custom-photo-greeting-cards',
    url: '/custom-photo-greeting-cards',
    customPage: true,
    image: 'categories/greeting-card',
    data: [
      {
        subCategories: [],
        products: ['photo-greeting-card', 'photo-greeting-card-foil'],
      },
    ],
  },
  {
    // TEMP CATEGORY ONLY FOR NAVIGATION
    id: 'cards',
    url: '/custom-photo-holiday-cards',
    customPage: true,
    image: 'categories/cards',
    name: 'Cards',
    data: [],
  },
  {
    id: 'new-books',
    url: '/new-books',
    image: 'categories/books',
    name: 'New Books 🚧',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['custom-books', 'custom-layflats', 'premium-hardcover-books'],
      },
    ],
  },
  {
    id: 'magnets',
    url: '/magnets',
    image: 'categories/magnets',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['acrylic-magnets', 'photobooth-magnets'],
      },
    ],
  },
];

export default PRODUCT_CATEGORIES;
